import React, { useState } from 'react';
import { siteData } from '../mock';

const Portfolio = () => {
  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Web3 Art', 'AI Art', 'Interactive', 'Web3 Tool'];

  const filteredProjects = filter === 'All' 
    ? siteData.portfolio 
    : siteData.portfolio.filter(project => project.category === filter);

  return (
    <section id="portfolio" className="py-20 lg:py-32 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      <div className="grain-overlay opacity-20"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="section-heading mb-6">
            SELECTED WORKS
          </h2>
          <p className="body-large max-w-2xl mx-auto opacity-80">
            A collection of experimental projects pushing the boundaries of web3 and AI
          </p>
        </div>

        {/* Filter Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={`service-button ${
                filter === category 
                  ? 'bg-pink-accent text-black border-pink-accent' 
                  : 'bg-white bg-opacity-10 text-white border-white border-opacity-20 hover:border-pink-accent'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {filteredProjects.map((project, index) => (
            <div
              key={project.id}
              className="project-card group cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden rounded-lg mb-4 aspect-square">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 grayscale hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-pink-accent opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                <div className="grain-overlay"></div>
              </div>
              
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-mono uppercase tracking-wider text-pink-accent">
                    {project.category}
                  </span>
                </div>
                
                <h3 className="text-xl lg:text-2xl font-bold group-hover:text-pink-accent transition-colors">
                  {project.title}
                </h3>
                
                <p className="text-sm lg:text-base opacity-70 leading-relaxed">
                  {project.description}
                </p>
                
                <div className="flex flex-wrap gap-2 pt-2">
                  {project.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="text-xs px-3 py-1 bg-white bg-opacity-5 border border-white border-opacity-20 rounded-full font-mono"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
